import { createSlice } from '@reduxjs/toolkit';

const languageSlice = createSlice({
  name: 'language',
  initialState: {
    count:0,
    limit:0,
    records:[]
  },
  reducers: {
    addLanguage: (state, action) => {
      return action.payload
    }
  },
});

export const { addLanguage } = languageSlice.actions;
export default languageSlice.reducer;
